import React from "react";
import Tooltip from "./tooltip";

function AppCards({ lang, translations, ...props }) {
  const isAndroid = /android/i.test(navigator.userAgent);

  const tooltipText = isAndroid
    ? translations[lang].soon
    : translations[lang].androidOnly ?? "Solo disponible para móviles Android";

  return (
    <div>
      {props.link ? (
        isAndroid ? (
          <a href={props.link} target="_blank" rel="nofollow">
            <img className="img-app" src={props.image} alt={props.alt || translations[lang].apptooltip} />
          </a>
        ) : (
          <Tooltip text={tooltipText}>
            <img className="img-app" src={props.image} alt={props.alt || translations[lang].apptooltip} />
          </Tooltip>
        )
      ) : (
        <Tooltip text={translations[lang].soon}>
          <img className="img-app" src={props.image} alt={props.alt || translations[lang].apptooltip} />
        </Tooltip>
      )}
    </div>
  );
}

export default AppCards;